import React from "react"

import {
  Grid,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core"
import { HashLink as Link } from "react-router-hash-link"

import ArrowBackIcon from "@material-ui/icons/ArrowBack"
import AddIcon from "@material-ui/icons/Add"
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle"
import CheckIcon from "@material-ui/icons/Check"
import ClearIcon from "@material-ui/icons/Clear"

import DateFnsUtils from "@date-io/date-fns"
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers"

import api from "../../services/api"

import "./EditCourse.scss"

class EditCourse extends React.Component {
  constructor() {
    super()

    this.state = {
      id: "",
      name: "",
      description1: "",
      description2: "",
      description1_pt: "",
      description2_pt: "",
      type: "",
      price: 0,
      duration: 0,
      active: false,

      newCalendar: [],
      isCalendar: false,
      newDay: new Date(),
      newHour: "08:00",
      limit: 1,

      showPastSlots: false,
      visiblePastMonths: 3,

      errorMessage: "",
      successMessage: "",
      saving: false,
    }
  }

  async componentDidMount() {
    const id = this.props.match.params.id

    try {
      const response = await api.get(`/courses/${id}`)
      const course = response.data.course

      this.setState({
        id,
        name: course?.name || "",
        description1: course?.description1 || "",
        description2: course?.description2 || "",
        description1_pt: course?.description1_pt || "",
        description2_pt: course?.description2_pt || "",
        type: course?.type || "",
        price: course?.price || 0,
        duration: course?.duration || 0,
        newCalendar: this.sortCalendar(
          Array.isArray(course?.calendar) ? course.calendar : [],
        ),
        active: !!course?.active,
      })
    } catch (error) {
      this.setState({
        errorMessage: "Could not load course information.",
      })
    }
  }

  getHourOptions() {
    return [
      "08:00",
      "08:30",
      "09:00",
      "09:30",
      "10:00",
      "10:30",
      "11:00",
      "11:30",
      "12:00",
      "12:30",
      "13:00",
      "13:30",
      "14:00",
      "14:30",
      "15:00",
      "15:30",
      "16:00",
      "16:30",
      "17:00",
      "17:30",
      "18:00",
      "18:30",
      "19:00",
    ]
  }

  isBaristaCourse() {
    const { id } = this.state

    return (
      id === "5f8b0c293fb21fbf08d0bc0f" || id === "68d587471fbc0c00152d004a"
    )
  }

  todayKey() {
    const d = new Date()
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, "0")
    const day = String(d.getDate()).padStart(2, "0")

    return `${year}-${month}-${day}`
  }

  toDateOnlyString(value) {
    if (!value) return ""

    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value
    }

    const date = new Date(value)

    if (Number.isNaN(date.getTime())) {
      return ""
    }

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")

    return `${year}-${month}-${day}`
  }

  formatDate(date) {
    if (!date) return ""

    const normalized = this.toDateOnlyString(date)
    if (!normalized) return ""

    const [year, month, day] = normalized.split("-")
    return `${day}/${month}/${year}`
  }

  formatMonth(monthKey) {
    const [year, month] = monthKey.split("-")

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ]

    return `${months[Number(month) - 1]} ${year}`
  }

  isPastSlot(day) {
    return this.toDateOnlyString(day) < this.todayKey()
  }

  sortCalendar(calendar) {
    if (!Array.isArray(calendar)) return []

    return [...calendar]
      .map((item) => ({
        day: this.toDateOnlyString(item.day),
        hour: String(item.hour || "").trim(),
        limit: Number(item.limit) || 0,
      }))
      .filter((item) => item.day && item.hour)
      .sort((a, b) => `${a.day} ${a.hour}`.localeCompare(`${b.day} ${b.hour}`))
  }

  groupCalendarByDate(calendar) {
    const grouped = {}

    this.sortCalendar(calendar).forEach((item) => {
      if (!grouped[item.day]) {
        grouped[item.day] = []
      }

      grouped[item.day].push(item)
    })

    return Object.keys(grouped)
      .sort()
      .map((date) => ({
        date,
        slots: grouped[date].sort((a, b) => a.hour.localeCompare(b.hour)),
      }))
  }

  groupCalendarByMonth(calendar) {
    const grouped = {}

    this.sortCalendar(calendar).forEach((item) => {
      const [year, month] = item.day.split("-")
      const monthKey = `${year}-${month}`

      if (!grouped[monthKey]) {
        grouped[monthKey] = []
      }

      grouped[monthKey].push(item)
    })

    return Object.keys(grouped)
      .sort((a, b) => b.localeCompare(a))
      .map((monthKey) => ({
        monthKey,
        days: this.groupCalendarByDate(grouped[monthKey]),
        totalSlots: grouped[monthKey].length,
      }))
  }

  calendarSlotExists(day, hour) {
    const { newCalendar } = this.state

    return newCalendar.some((item) => {
      return (
        this.toDateOnlyString(item.day) === day &&
        String(item.hour).trim() === String(hour).trim()
      )
    })
  }

  handleCalendar() {
    const { newCalendar, newDay, newHour, limit } = this.state

    const normalizedDay = this.toDateOnlyString(newDay)
    const normalizedHour = String(newHour || "").trim()
    const normalizedLimit = Number(limit)

    this.setState({
      errorMessage: "",
      successMessage: "",
    })

    if (!normalizedDay || !normalizedHour || !normalizedLimit) {
      this.setState({
        errorMessage: "Please fill date, hour and limit before adding a slot.",
      })
      return
    }

    if (normalizedLimit <= 0) {
      this.setState({
        errorMessage: "Limit must be greater than zero.",
      })
      return
    }

    if (this.calendarSlotExists(normalizedDay, normalizedHour)) {
      this.setState({
        errorMessage: "This date and hour already exists in the calendar.",
      })
      return
    }

    const newItem = {
      day: normalizedDay,
      hour: normalizedHour,
      limit: normalizedLimit,
    }

    this.setState({
      newCalendar: this.sortCalendar([...newCalendar, newItem]),
      isCalendar: false,
      newDay: new Date(),
      newHour: "08:00",
      limit: 1,
      successMessage: "Calendar slot added. Remember to click Save.",
    })
  }

  handleRemoveCalendar(index) {
    const { newCalendar } = this.state
    const slot = newCalendar[index]

    const confirmRemove = window.confirm(
      `Remove this slot?\n\n${this.formatDate(slot?.day)} - ${
        slot?.hour
      }\n\nIf this slot already has bookings, the backend will block the save.`,
    )

    if (!confirmRemove) return

    const updatedCalendar = newCalendar.filter((_, i) => i !== index)

    this.setState({
      newCalendar: updatedCalendar,
      isCalendar: false,
      errorMessage: "",
      successMessage: "Calendar slot removed. Remember to click Save.",
    })
  }

  handleUpdateSlotLimit(index, value) {
    const { newCalendar } = this.state
    const updatedCalendar = [...newCalendar]

    updatedCalendar[index] = {
      ...updatedCalendar[index],
      limit: value,
    }

    this.setState({
      newCalendar: updatedCalendar,
      errorMessage: "",
      successMessage: "",
    })
  }

  handleLoadMorePastMonths() {
    this.setState((prevState) => ({
      visiblePastMonths: prevState.visiblePastMonths + 3,
    }))
  }

  async handleSubmit() {
    const {
      id,
      name,
      description1,
      description2,
      description1_pt,
      description2_pt,
      type,
      price,
      duration,
      newCalendar,
      active,
    } = this.state

    this.setState({
      errorMessage: "",
      successMessage: "",
    })

    if (
      !name ||
      !name.trim() ||
      !description1 ||
      !description1.trim() ||
      !description1_pt ||
      !description1_pt.trim()
    ) {
      this.setState({
        errorMessage:
          "Name, Description 1 (English), and Descrição 1 (Portuguese) cannot be empty.",
      })
      return
    }

    try {
      this.setState({ saving: true })

      await api.put(`/courses/${id}`, {
        name,
        description1,
        description2,
        description1_pt,
        description2_pt,
        type,
        price: Number(price),
        duration: Number(duration),
        calendar: this.sortCalendar(newCalendar).map((item) => ({
          day: this.toDateOnlyString(item.day),
          hour: item.hour,
          limit: Number(item.limit),
        })),
        active,
      })

      this.setState({
        saving: false,
        successMessage: "Course updated successfully.",
      })
    } catch (error) {
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.details ||
        ""

      let friendlyMessage =
        backendMessage || "This course could not be updated. Please try again."

      if (
        backendMessage.toLowerCase().includes("booking") ||
        backendMessage.toLowerCase().includes("booked") ||
        backendMessage.toLowerCase().includes("calendar") ||
        backendMessage.toLowerCase().includes("slot") ||
        backendMessage.toLowerCase().includes("limit")
      ) {
        friendlyMessage =
          "This calendar change could not be saved. Please check the course slots and try again."
      }

      this.setState({
        saving: false,
        errorMessage: friendlyMessage,
      })
    }
  }

  renderCalendarGroups(groupedCalendar, isPast = false) {
    const { newCalendar } = this.state

    if (!groupedCalendar.length) {
      return <p className="empty-calendar">No calendar slots found.</p>
    }

    return (
      <div className="calendar-list">
        {groupedCalendar.map((group) => (
          <div
            className={`calendar-day-card ${isPast ? "past" : ""}`}
            key={group.date}
          >
            <h5>{this.formatDate(group.date)}</h5>

            {group.slots.map((item) => {
              const originalIndex = newCalendar.findIndex((calendarItem) => {
                return (
                  this.toDateOnlyString(calendarItem.day) === item.day &&
                  String(calendarItem.hour).trim() === item.hour
                )
              })

              return (
                <div
                  className={`calendar-slot-row ${isPast ? "past" : ""}`}
                  key={`${item.day}-${item.hour}`}
                >
                  <div className="slot-time">
                    <strong>{item.hour}</strong>
                    <span>{isPast ? "Past slot" : "Available slot"}</span>
                  </div>

                  <div className="slot-limit">
                    <InputLabel>Limit</InputLabel>
                    <TextField
                      className="form-input"
                      type="number"
                      value={item.limit}
                      inputProps={{ min: 0 }}
                      onChange={(e) =>
                        this.handleUpdateSlotLimit(
                          originalIndex,
                          e.target.value,
                        )
                      }
                    />
                  </div>

                  <Button
                    className="remove-slot-button"
                    onClick={() => this.handleRemoveCalendar(originalIndex)}
                  >
                    <RemoveCircleIcon /> Remove
                  </Button>
                </div>
              )
            })}
          </div>
        ))}
      </div>
    )
  }

  renderPastCalendarMonths(groupedPastMonths) {
    return (
      <div className="past-month-list">
        {groupedPastMonths.map((month) => (
          <div className="calendar-month-card" key={month.monthKey}>
            <div className="calendar-month-header">
              <h4>{this.formatMonth(month.monthKey)}</h4>
              <span>{month.totalSlots} slots</span>
            </div>

            {this.renderCalendarGroups(month.days, true)}
          </div>
        ))}
      </div>
    )
  }

  renderCalendarSection() {
    const {
      newCalendar,
      isCalendar,
      newDay,
      newHour,
      limit,
      showPastSlots,
      visiblePastMonths,
    } = this.state

    const upcomingCalendar = newCalendar.filter(
      (item) => !this.isPastSlot(item.day),
    )

    const pastCalendar = newCalendar.filter((item) => this.isPastSlot(item.day))

    const groupedUpcomingCalendar = this.groupCalendarByDate(upcomingCalendar)
    const groupedPastMonths = this.groupCalendarByMonth(pastCalendar)
    const visibleGroupedPastMonths = groupedPastMonths.slice(
      0,
      visiblePastMonths,
    )
    const hasMorePastMonths = groupedPastMonths.length > visiblePastMonths

    return (
      <div className="calendar-section">
        <Grid item xs={12}>
          <h4>Calendar</h4>
          <p className="calendar-helper">
            Add available Barista course slots by date and hour. Past slots are
            kept for history and reports, but hidden by default.
          </p>
        </Grid>

        <Grid item xs={12}>
          {!isCalendar ? (
            <Button
              className="edit-button"
              onClick={() =>
                this.setState({
                  isCalendar: true,
                  errorMessage: "",
                  successMessage: "",
                })
              }
            >
              <AddIcon /> Add Date / Hour
            </Button>
          ) : (
            ""
          )}
        </Grid>

        {isCalendar ? (
          <div className="calendar-new">
            <Grid item xs={12} sm={4}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disablePast
                  margin="normal"
                  id="date-picker-dialog"
                  label="Date"
                  format="dd/MM/yyyy"
                  value={newDay}
                  onChange={(date) =>
                    this.setState({
                      newDay: date || new Date(),
                    })
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid className="form-select" item xs={12} sm={3}>
              <InputLabel>Hour</InputLabel>
              <Select
                className="form-input"
                required
                labelId="select-label"
                value={newHour}
                onChange={(e) => this.setState({ newHour: e.target.value })}
              >
                {this.getHourOptions().map((hour) => (
                  <MenuItem value={hour} key={hour}>
                    {hour}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                className="form-input"
                id="limit"
                label="Limit"
                type="number"
                value={limit}
                inputProps={{ min: 1 }}
                onChange={(e) => this.setState({ limit: e.target.value })}
              />
            </Grid>

            <Grid className="calendar-actions" item xs={12} sm={3}>
              <Button
                className="calendar-confirm"
                onClick={() => this.handleCalendar()}
              >
                <CheckIcon /> Add
              </Button>

              <Button
                className="calendar-cancel"
                onClick={() =>
                  this.setState({
                    isCalendar: false,
                    newDay: new Date(),
                    newHour: "08:00",
                    limit: 1,
                  })
                }
              >
                <ClearIcon /> Cancel
              </Button>
            </Grid>
          </div>
        ) : (
          ""
        )}

        <Grid item xs={12}>
          <h4>Upcoming slots</h4>
          {this.renderCalendarGroups(groupedUpcomingCalendar)}

          {pastCalendar.length > 0 ? (
            <div className="past-slots-section">
              <button
                type="button"
                className="toggle-past-slots"
                onClick={() =>
                  this.setState({
                    showPastSlots: !showPastSlots,
                    visiblePastMonths: 3,
                  })
                }
              >
                {showPastSlots
                  ? "Hide past slots"
                  : `Show past slots (${pastCalendar.length})`}
              </button>

              {showPastSlots ? (
                <>
                  <h4>Past slots</h4>

                  {this.renderPastCalendarMonths(visibleGroupedPastMonths)}

                  {hasMorePastMonths ? (
                    <button
                      type="button"
                      className="load-more-past-slots"
                      onClick={() => this.handleLoadMorePastMonths()}
                    >
                      Load more past months
                    </button>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
        </Grid>
      </div>
    )
  }

  render() {
    const {
      name,
      description1,
      description2,
      description1_pt,
      description2_pt,
      type,
      price,
      duration,
      active,
      errorMessage,
      successMessage,
      saving,
    } = this.state

    return (
      <div className="container edit">
        <div className="edit-header">
          <div>
            <p className="eyebrow">Admin area</p>
            <h1>Edit Course</h1>
          </div>

          <Link className="back-link" to="/dashboard/courses">
            <ArrowBackIcon /> Back to Courses
          </Link>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            this.handleSubmit()
          }}
          className="form-container"
          noValidate
          autoComplete="off"
        >
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6}>
              <Grid item xs={12}>
                <h4>English</h4>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  className="form-input"
                  required
                  id="name"
                  label="Name"
                  type="text"
                  value={name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  className="form-input"
                  required
                  id="description1"
                  label="Description 1"
                  multiline
                  rows={5}
                  value={description1}
                  onChange={(e) =>
                    this.setState({ description1: e.target.value })
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  className="form-input"
                  id="description2"
                  label="Description 2"
                  multiline
                  rows={5}
                  value={description2}
                  onChange={(e) =>
                    this.setState({ description2: e.target.value })
                  }
                />
              </Grid>

              {type !== "online" && this.isBaristaCourse()
                ? this.renderCalendarSection()
                : ""}
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid item xs={12}>
                <h4>Portuguese</h4>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  className="form-input"
                  required
                  id="description1_pt"
                  label="Descrição 1"
                  multiline
                  rows={5}
                  value={description1_pt}
                  onChange={(e) =>
                    this.setState({ description1_pt: e.target.value })
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  className="form-input"
                  id="description2_pt"
                  label="Descrição 2"
                  multiline
                  rows={5}
                  value={description2_pt}
                  onChange={(e) =>
                    this.setState({ description2_pt: e.target.value })
                  }
                />
              </Grid>

              <Grid className="form-select" item xs={12}>
                <InputLabel id="select-label">Type</InputLabel>
                <Select
                  className="form-input"
                  required
                  labelId="select-label"
                  id="type"
                  value={type}
                  onChange={(e) => this.setState({ type: e.target.value })}
                >
                  <MenuItem value={"online"}>Online</MenuItem>
                  <MenuItem value={"face-to-face"}>Face-to-face</MenuItem>
                </Select>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  className="form-input"
                  required
                  id="price"
                  label="Price"
                  type="number"
                  value={price}
                  onChange={(e) => this.setState({ price: e.target.value })}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  className="form-input"
                  required
                  id="duration"
                  label="Duration(days)"
                  type="number"
                  value={duration}
                  onChange={(e) => this.setState({ duration: e.target.value })}
                />
              </Grid>

              <Grid className="form-select" item xs={12}>
                <InputLabel id="select-active">Active</InputLabel>
                <Select
                  className="form-input"
                  required
                  labelId="select-active"
                  id="active"
                  value={active}
                  onChange={(e) => this.setState({ active: e.target.value })}
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </Select>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Button
                className="btn-save float-r"
                type="submit"
                disabled={saving}
              >
                {saving ? "Saving..." : "Save"}
              </Button>

              <Link className="btn-cancel float-r" to="/dashboard/courses">
                Cancel
              </Link>
            </Grid>
          </Grid>
        </form>

        {errorMessage ? (
          <div className="form-error-message">{errorMessage}</div>
        ) : (
          ""
        )}

        {successMessage ? (
          <div className="form-success-message">{successMessage}</div>
        ) : (
          ""
        )}
      </div>
    )
  }
}

export default EditCourse
